module.exports = __webpack_public_path__ + "media/images/bg/left_bg-b564b0ae884943437d78b7bc1295fffc.jpg";